import React, { useState, useRef } from "react";
import "./EvaSlider.css";

export default function EvaSlider({
    question,
    info,
    onRelease,
    onTextChange,
    scaleSize = 8
}) {
    // 0 = reset / no answer
    const [value, setValue] = useState(0);
    const [dragging, setDragging] = useState(false);
    const [showInfo, setShowInfo] = useState(false);

    const sliderRef = useRef(null);

    // Now includes reset slot
    const maxIndex = scaleSize;

    function commitValue(newValue) {

        setValue(newValue);

        if (onRelease) {
            if (newValue > 0) {
                onRelease(newValue); // 1–8
            } else {
                onRelease(null);     // reset / unanswered
            }
        }
    }

    function handleMouseDown() {
        setDragging(true);
    }

    function handleMouseUp() {

        if (dragging) {
            setDragging(false);
            commitValue(value);
        }
    }

    function handleMouseMove(e) {

        if (!dragging) {
            return;
        }

        const rect = sliderRef.current.getBoundingClientRect();
        const x = e.clientX - rect.left;

        let newVal = Math.round((x / rect.width) * maxIndex);

        if (newVal < 0) {
            newVal = 0;
        }

        if (newVal > maxIndex) {
            newVal = maxIndex;
        }

        setValue(newVal);
    }

    function handleBoxClick(index) {
        commitValue(index);
    }

    return (
        <div
            className="eva-slider-container"
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            style={{
                marginLeft: "20px",
                marginRight: "20px",
                width: "calc(100% - 40px)"
            }}
        >
            {/* QUESTION + INFO ICON */}
            <div className="eva-question-header">
                <div className="eva-question-title">{question}</div>

                <div className="eva-info-icon">
                    i
                    <div className="eva-info-popup">{info}</div>
                </div>
            </div>

            {/* TOP BOXES */}
            <div className="eva-box-row">

                {/* RESET BOX */}
                <div className="eva-box-wrapper">
                    <div
                        className={`eva-box eva-box-reset ${
                            value === 0 ? "active" : ""
                        }`}
                        onClick={function () {
                            handleBoxClick(0);
                        }}
                        style={{ cursor: "pointer", display:'none' }}
                    >
                        ×
                    </div>

                    <div
                        className={`eva-connector ${
                            value > 0 ? "active" : ""
                        }`}
                    />
                </div>

                {/* SCALE BOXES */}
                {[...Array(scaleSize)].map(function (_, i) {

                    const index = i + 1;

                    return (
                        <div key={index} className="eva-box-wrapper">
                            <div
                                className={`eva-box ${
                                    value >= index ? "active" : ""
                                }`}
                                onClick={function () {
                                    handleBoxClick(index);
                                }}
                                style={{ cursor: "pointer" }}
                            >
                                {index}
                            </div>

                            {index < maxIndex && (
                                <div
                                    className={`eva-connector ${
                                        value > index ? "active" : ""
                                    }`}
                                />
                            )}
                        </div>
                    );
                })}
            </div>

            {/* SLIDER TRACK */}
            <div className="eva-track" ref={sliderRef}>
                <div
                    className={`eva-thumb ${dragging ? "dragging" : ""}`}
                    style={{
                        left: `calc(${(value / maxIndex) * 100}% - 16px)`
                    }}
                    onMouseDown={handleMouseDown}
                >
                    <div className="eva-thumb-dot"></div>
                </div>
            </div>

            {/* INFO PANEL */}
            <div className="eva-info-wrapper">
                {showInfo && (
                    <div className="eva-info-panel open">
                        <div
                            className="eva-info-close"
                            onClick={function () {
                                setShowInfo(false);
                            }}
                        >
                            ×
                        </div>

                        <div className="eva-info-header">
                            Why did you choose this score?
                        </div>

                        <textarea
                            className="eva-info-textarea"
                            placeholder="Add more details here..."
                            onChange={function (e) {
                                if (onTextChange) {
                                    onTextChange(e.target.value);
                                }
                            }}
                        />
                    </div>
                )}

                {!showInfo && (
                    <div
                        className="eva-info-reopen"
                        onClick={function () {
                            setShowInfo(true);
                        }}
                    >
                        Add more details about why you selected this score…
                    </div>
                )}
            </div>
        </div>
    );
}
